__turbopack_context__.v({
  "button": "ThemeToggle-module__QEChaW__button",
  "dark": "ThemeToggle-module__QEChaW__dark",
  "light": "ThemeToggle-module__QEChaW__light",
});
